/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * Banner action kind enumeration.
 */
export type BannerActionKind = typeof BannerActionKind[keyof typeof BannerActionKind];


export const BannerActionKind = {
  user_profile: 'user_profile',
  shelf: 'shelf',
  categories: 'categories',
  paywall: 'paywall',
  book: 'book',
  collection: 'collection',
  category: 'category',
} as const;
